import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowDownThinIcon } from 'images'
import LoadingSpinner, { SpinnerSize } from './LoadingSpinner'

/**
 * Buttons
 * @Tags( shared, presentational, buttons, CTA )
 */

// TODO: refactor this
import { DemandPredictionIcon, LookoutSVGIcon, SalesBoostIcon, WaveSVGIcon } from 'images'

const eventRowButtonMap = {
  SALES_BOOST: {
    icon: <SalesBoostIcon width={26} />,
  },
  DEMAND_PREDICTION: {
    icon: <DemandPredictionIcon width={26} />,
  },
  LOOKOUT: {
    icon: <LookoutSVGIcon width={26} />,
  },
  WAVES: {
    icon: <WaveSVGIcon width={26} />,
  },
}

const PrimaryButton = ({
  type = 'submit',
  onClick = () => {},
  text,
  showIcon,
  linkTo = null,
  disabled = false,
  disabledTitle = 'You are not authorized to perform this action. Please contact your admin',
  hidden = false,
  cypressId = 'button',
  fullWidth = true,
  className = '',
}) => {
  if (linkTo && !disabled) {
    if (linkTo.startsWith('http') || linkTo.startsWith('www')) {
      return (
        <a href={linkTo} target="_blank" rel="noopener noreferrer">
          <button
            type="button"
            title={disabled ? disabledTitle : text}
            data-cy={cypressId}
            style={hidden ? { display: 'none' } : {}}
            disabled={disabled}
            className={`bt bt-orange s-38 ${fullWidth ? 'w-100' : ''} ${className}`}
          >
            <span>{text}</span>
            {showIcon ? <i className="icon-arrow-right ml-3"></i> : <></>}
          </button>
        </a>
      )
    }

    return (
      <Link to={linkTo}>
        <button
          type="button"
          title={disabled ? disabledTitle : text}
          data-cy={cypressId}
          style={hidden ? { display: 'none' } : {}}
          disabled={disabled}
          className={`bt bt-orange s-38 ${fullWidth ? 'w-100' : ''} ${className}`}
        >
          <span>{text}</span>
          {showIcon ? <i className="icon-arrow-right ml-3"></i> : <></>}
        </button>
      </Link>
    )
  }

  return (
    <button
      title={disabled ? disabledTitle : text}
      data-cy={cypressId}
      style={hidden ? { display: 'none' } : {}}
      disabled={disabled}
      onClick={onClick}
      className={`bt bt-orange s-38 ${fullWidth ? 'w-100' : ''} ${className}`}
      type={type}
    >
      <span>{text}</span>
      {showIcon ? <i className="icon-arrow-right ml-3"></i> : <></>}
    </button>
  )
}
export const ButtonWithExternalHref = ({
  fullWidth = true,
  text,
  showIcon,
  isBackArrow = false,
  externalUrl,
  disabled = false,
  color = 'orange',
  cypressId = 'button',
  onClick,
}) => {
  return (
    <a href={externalUrl} target="_blank" rel="noopener noreferrer">
      <button
        type="button"
        onClick={onClick}
        title={
          disabled
            ? 'You are not authorized to perform this action. Please contact your admin'
            : text
        }
        data-cy={cypressId}
        disabled={disabled}
        className={`bt ${color === 'orange' ? 'bt-orange' : 'bt-navy'} s-38 ${fullWidth ? 'w-100' : ''}`}
      >
        {showIcon && isBackArrow ? <i className="icon-arrow-left mr-3"></i> : <></>}
        <span style={{ whiteSpace: 'nowrap' }}>{text}</span>
        {showIcon && !isBackArrow ? <i className="icon-arrow-right ml-3"></i> : <></>}
      </button>
    </a>
  )
}
export const SecondaryButton = ({
  onClick = () => {},
  extraStyles = {},
  additionalComponent = null,
  fullWidth = true,
  text,
  disabledTitle,
  showIcon,
  children,
  isBackArrow = false,
  linkTo = null,
  disabled = false,
  loading = false,
  color = 'orange',
  cypressId = 'button',
  size = 'normal',
  classNames = '',
  type = 'button',
  onHover = () => {},
}) => {
  const sizes = {
    small: 's-24',
    normal: 's-38',
    big: 's-50',
  }

  const isDisabled = disabled || loading

  const buttonContent = (
    <>
      {showIcon && isBackArrow ? <i className="icon-arrow-left mr-3"></i> : <></>}
      {loading && (
        <LoadingSpinner
          className="bt-loading-spinner"
          showText={false}
          size={SpinnerSize.SMALL}
          portalBackground={false}
        />
      )}
      {children ? <>{children}</> : <span style={{ whiteSpace: 'nowrap' }}>{text}</span>}
      {additionalComponent && <div className="ml-3">{additionalComponent}</div>}
      {showIcon && !isBackArrow ? <i className="icon-arrow-right ml-3"></i> : <></>}
    </>
  )

  if (disabledTitle === null || disabledTitle === undefined)
    disabledTitle = 'You are not authorized to perform this action. Please contact your admin'

  if (linkTo && !isDisabled) {
    if (linkTo.startsWith('http') || linkTo.startsWith('www')) {
      return (
        <a href={linkTo} target="_blank" rel="noopener noreferrer" className={classNames}>
          <button
            type={type}
            style={{ ...extraStyles }}
            onMouseEnter={() => onHover(true)}
            onMouseLeave={() => onHover(false)}
            title={isDisabled ? disabledTitle : text}
            data-cy={cypressId}
            onClick={onClick}
            disabled={isDisabled}
            className={`bt ${color === 'orange' ? 'bt-orange' : 'bt-navy'} ${sizes[size]} ${
              fullWidth ? 'w-100' : ''
            }`}
          >
            {buttonContent}
          </button>
        </a>
      )
    }
    return (
      <Link to={linkTo} className={classNames}>
        <button
          type={type}
          style={{ ...extraStyles }}
          onMouseEnter={() => onHover(true)}
          onMouseLeave={() => onHover(false)}
          title={isDisabled ? disabledTitle : text}
          data-cy={cypressId}
          onClick={onClick}
          disabled={isDisabled}
          className={`bt ${color === 'orange' ? 'bt-orange' : 'bt-navy'} ${sizes[size]} ${fullWidth ? 'w-100' : ''}`}
        >
          {buttonContent}
        </button>
      </Link>
    )
  }
  return (
    <button
      type={type}
      style={{ ...extraStyles }}
      onMouseEnter={() => onHover(true)}
      onMouseLeave={() => onHover(false)}
      title={isDisabled ? disabledTitle : text}
      data-cy={cypressId}
      onClick={onClick}
      disabled={isDisabled}
      className={`${classNames} bt ${color === 'orange' ? 'bt-orange' : 'bt-navy'} ${sizes[size]} ${fullWidth ? 'w-100' : ''}`}
    >
      {buttonContent}
    </button>
  )
}

export const FullWidthButton = ({
  extraStyles,
  onClick = () => {},
  additionalComponent = null,
  text,
  showIcon,
  isBackArrow = false,
  linkTo = null,
  disabled = false,
  color = 'orange',
  cypressId = 'full-w-button',
}) => {
  if (linkTo && !disabled) {
    return (
      <Link to={linkTo} style={{ width: '100%' }}>
        <button
          type="button"
          style={{ width: '100%', ...extraStyles }}
          title={
            disabled
              ? 'You are not authorized to perform this action. Please contact your admin'
              : text
          }
          data-cy={cypressId}
          onClick={onClick}
          disabled={disabled}
          className={`bt ${color === 'orange' ? 'bt-orange' : 'bt-navy'} s-38`}
        >
          {showIcon && isBackArrow ? <i className="icon-arrow-left mr-3"></i> : <></>}
          <span>{text}</span>
          {additionalComponent && <div className="ml-3">{additionalComponent}</div>}
          {showIcon && !isBackArrow ? <i className="icon-arrow-right ml-3"></i> : <></>}
        </button>
      </Link>
    )
  }
  return (
    <button
      type="button"
      style={{ width: '100%', ...extraStyles }}
      title={
        disabled ? 'You are not authorized to perform this action. Please contact your admin' : text
      }
      data-cy={cypressId}
      onClick={onClick}
      disabled={disabled}
      className={`bt ${color === 'orange' ? 'bt-orange' : 'bt-navy'} s-38`}
    >
      {showIcon && isBackArrow ? <i className="icon-arrow-left mr-3"></i> : <></>}
      <span>{text}</span>
      {additionalComponent && <div className="ml-3">{additionalComponent}</div>}
      {showIcon && !isBackArrow ? <i className="icon-arrow-right ml-3"></i> : <></>}
    </button>
  )
}

export const DownloadButton = ({
  onClick = () => {},
  text,
  showIcon,
  disabled = false,
  color = 'orange',
  cypressId = 'button',
}) => {
  return (
    <button
      type="button"
      title={
        disabled ? 'You are not authorized to perform this action. Please contact your admin' : text
      }
      data-cy={cypressId}
      onClick={onClick}
      disabled={disabled}
      className={`bt ${color === 'orange' ? 'bt-orange' : 'bt-navy'} s-38 w-100`}
    >
      <span>{text}</span>
      {showIcon ? <i style={{ marginLeft: '1em' }} className="icon-arrow-down2"></i> : <></>}
    </button>
  )
}

export const IconButton = ({
  iconType,
  linkTo,
  onClick = () => {},
  showIcon,
  disabled = false,
  color = 'orange',
  extraStyles = {},
  cypressId = 'button',
}) => {
  if (linkTo && !disabled) {
    return (
      <Link to={linkTo}>
        <button
          type="button"
          title={
            disabled
              ? 'You are not authorized to perform this action. Please contact your admin'
              : ''
          }
          style={{ padding: '8px', ...extraStyles }}
          onClick={onClick}
          disabled={disabled}
          className={`bt ${color === 'orange' ? 'bt-orange' : 'bt-navy'} s-24 `}
        >
          <i style={{ fontSize: 18 }} className={`icon-${iconType}`}></i>
          {showIcon ? (
            <i style={{ marginLeft: 18, fontSize: 10 }} className="icon-arrow-right"></i>
          ) : (
            <></>
          )}
        </button>
      </Link>
    )
  }
  return (
    <button
      type="button"
      title={
        disabled ? 'You are not authorized to perform this action. Please contact your admin' : ''
      }
      data-cy={cypressId}
      style={{ padding: '8px', ...extraStyles }}
      onClick={onClick}
      disabled={disabled}
      className={`bt ${color === 'orange' ? 'bt-orange' : 'bt-navy'} s-24 `}
    >
      <i style={{ fontSize: 18 }} className={`icon-${iconType}`}></i>
      {showIcon ? (
        <i style={{ marginLeft: 18, fontSize: 10 }} className="icon-arrow-right"></i>
      ) : (
        <></>
      )}
    </button>
  )
}
export const EventRowButton = ({
  type = 'DEMAND_PREDICTION',
  linkTo,
  onClick = () => {},
  showIcon,
  disabled = false,
  extraStyles = {},
  cypressId = 'button',
  classNames = '',
}) => {
  if (linkTo && !disabled) {
    return (
      <Link to={linkTo}>
        <button
          type="button"
          title={
            disabled
              ? 'You are not authorized to perform this action. Please contact your admin'
              : ''
          }
          data-cy={cypressId}
          style={{ boxSizing: 'border-box', ...extraStyles }}
          onClick={onClick}
          disabled={disabled}
          className={`bttn ${classNames}`}
        >
          <span className="content">
            {eventRowButtonMap[type].icon}
            {showIcon ? (
              <i style={{ marginLeft: 13, fontSize: 13 }} className="icon-arrow-right"></i>
            ) : (
              <></>
            )}
          </span>
          <span className="background" />
        </button>
      </Link>
    )
  }
  return (
    <button
      type="button"
      title={
        disabled ? 'You are not authorized to perform this action. Please contact your admin' : ''
      }
      data-cy={cypressId}
      style={{ boxSizing: 'border-box', ...extraStyles }}
      onClick={onClick}
      disabled={disabled}
      className={`bttn ${classNames}`}
    >
      <span className="content">
        {eventRowButtonMap[type].icon}
        {showIcon ? (
          <i style={{ marginLeft: 13, fontSize: 13 }} className="icon-arrow-right"></i>
        ) : (
          <></>
        )}
      </span>
      <span className="background" />
    </button>
  )
}

export const DashedBorderedButton = ({
  iconType,
  text,
  linkTo,
  onClick = () => {},
  showIcon,
  disabled = false,
  color = 'orange',
  extraStyles = {},
  cypressId = 'button',
}) => {
  const defaultStyles = { padding: '8px' }

  if (linkTo && !disabled) {
    return (
      <Link to={linkTo}>
        <button
          type="button"
          title={
            disabled
              ? 'You are not authorized to perform this action. Please contact your admin'
              : text
          }
          style={{ ...defaultStyles, ...extraStyles }}
          onClick={onClick}
          disabled={disabled}
          className={`bt dashed ${color === 'orange' ? 'orange' : 'navy'} `}
        >
          <i style={{ fontSize: 18 }} className={`icon-${iconType}`}></i>
          <span>{text}</span>
          {showIcon ? (
            <i style={{ marginLeft: 18, fontSize: 10 }} className="icon-arrow-right"></i>
          ) : (
            <></>
          )}
        </button>
      </Link>
    )
  }
  return (
    <button
      type="button"
      title={
        disabled ? 'You are not authorized to perform this action. Please contact your admin' : text
      }
      data-cy={cypressId}
      style={{ ...defaultStyles, ...extraStyles }}
      onClick={onClick}
      className={`bt dashed ${color === 'orange' ? 'orange' : 'navy'} s-24`}
    >
      <i style={{ fontSize: 18 }} className={`icon-${iconType}`}></i>
      <span>{text}</span>
      {showIcon ? (
        <i style={{ marginLeft: 18, fontSize: 10 }} className="icon-arrow-right"></i>
      ) : (
        <></>
      )}
    </button>
  )
}
export const TransparentBgButton = ({
  type = 'submit',
  classNames,
  text,
  linkTo,
  onClick = () => {},
  leftIcon = null,
  rightIcon = null,
  disabled = false,
  disabledTitle,
  color = 'orange',
  extraStyles = {},
  cypressId = 'button',
  size = 'normal',
  light = false,
  inverted = false,
}) => {
  const sizes = {
    small: 's-24',
    normal: 's-38',
    big: 's-50',
  }

  if (disabledTitle === null || disabledTitle === undefined)
    disabledTitle = 'You are not authorized to perform this action. Please contact your admin'

  const hasCustomIcon = Boolean(leftIcon || rightIcon)

  if (linkTo && !disabled) {
    return (
      <Link to={linkTo}>
        <button
          title={disabled ? disabledTitle : text}
          style={{ ...extraStyles }}
          onClick={onClick}
          disabled={disabled}
          className={`bt hollow ${color === 'orange' ? 'orange' : 'navy'} ${sizes[size]} ${light ? 'hollow--light' : ''} ${hasCustomIcon ? 'bt-icon-gap' : ''}`}
        >
          {leftIcon && <span className="bt-custom-icon">{leftIcon}</span>}
          <span>{text}</span>
          {rightIcon && <span className="bt-custom-icon">{rightIcon}</span>}
        </button>
      </Link>
    )
  }
  return (
    <button
      title={disabled ? disabledTitle : text}
      type={type}
      disabled={disabled}
      data-cy={cypressId}
      style={{ ...extraStyles }}
      onClick={onClick}
      className={`bt hollow ${color === 'orange' ? 'orange' : color === 'navy-light' ? 'navy-light' : 'navy'} ${sizes[size]} ${classNames} ${light ? 'hollow--light' : ''} ${inverted ? 'hollow--inverted' : ''} ${hasCustomIcon ? 'bt-icon-gap' : ''}`}
    >
      {leftIcon && <span className="bt-custom-icon">{leftIcon}</span>}
      <span>{text}</span>
      {rightIcon && <span className="bt-custom-icon">{rightIcon}</span>}
    </button>
  )
}

export const DropdownButton = ({
  onClick = () => {},
  text,
  isOpen = false,
  disabled = false,
  color = 'orange',
  classNames = '',
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-expanded={isOpen}
      className={`bt dropdown-button ${color === 'orange' ? 'bt-orange' : 'bt-navy'} s-38 ${isOpen ? 'open' : ''} ${classNames}`}
    >
      <span>{text}</span>

      <div className="divider" role="presentation" />

      <span className="dropdown-button__chevron" aria-hidden="true">
        <ArrowDownThinIcon width={24} height={24} />
      </span>
    </button>
  )
}

export default PrimaryButton
